import { isProduction } from '../../const';
export var delay = isProduction ? 40 : 60;
//# sourceMappingURL=index.js.map